import { useMemo } from "react"
import { atom, DefaultValue, selector, selectorFamily, useRecoilState, useRecoilValueLoadable, useResetRecoilState, useSetRecoilState } from "recoil"
import { ImageUtils } from "../framework/utils"
import { News } from "../models/News"
import apiService from "../services/api"
import apiNews from "../services/api"
import { areeMySixtemaState } from "../utils/hooks"
import { notaOpAtom, notaOpRequestNumberState } from "./notaOperativa"

export const newsRequestNumberState = atom({
    key: 'newsRequestNumberState',
    default: 1
})

//Get all last news
export const newsState = selector({
    key: 'newsState',
    get: async ({get}) => {
        get(newsRequestNumberState)
        const options = get(newsOptionsState)
        const areeArray = get(areeMySixtemaState)
        const aree = areeArray.join(';') + ';'
        //console.log(`%careeArray: ${JSON.stringify(areeArray)} => ${aree}`, logConstants.blue10ptBold)

        if(options.viewAll) {
            return apiNews.getAllNews(aree, options.limit) ?? []
        } else {
            return apiNews.getValidNews(aree, options.limit) ?? []
        }
    }
})

export const newsListAtom = atom<News[]>({
    key: 'newsListAtom',
    default: [],
})

export const defaultNewsAtom: News = {
    id: 0,
    userCre: '',
    dateCre: null,
    userUpd: '',
    dateUpd: null,
    title: '',
    subtitle: '',
    body: 'TBD',
    important: false,
    validUntil: '',
    aree: '',
    expired: false,
    notaOperativa: false,
    newsImage: null,
    fileEncoded: '',
    publish: true,
    notify: false,
    managed: null,
    livelli: '',
    province: ''
}

export const newsAtom = atom<News>({
    key: 'newsAtom',
    default: defaultNewsAtom
})

export const getNewsById = selectorFamily({
    key: 'getNewsById',
    get: (id: number) => async ({ get }) => {
        get(newsRequestNumberState)
        //const us = get(userSettingSelected)
        const ns = await apiService.getNews(id)
        // if (ns && ns.fileEncoded) {
        //     result = ImageUtils.fromBase64ToDataUrl(ns.fileEncoded, 'png')
        // }
        return ns;
    }
})

export const newsImageDataSelector = selectorFamily({
    key: 'newsImageDataSelector',
    get: (id: number) =>  async ({ get }) => {
        let result: string = ''        
        get(newsRequestNumberState)
        //const news = get(newsAtom)
        const ns = await apiService.getNews(id)
        if (ns && ns.fileEncoded) {
            result = ImageUtils.fromBase64ToDataUrl(ns.fileEncoded, 'png')
            //console.log({result})
        }
        return result;
    }
})

export const useTypeNews = (type: string | undefined) => {
    const [news, setNews] = useRecoilState(type === '0' ? newsAtom : notaOpAtom)
    const resetNews = useResetRecoilState(type === '0' ? newsAtom : notaOpAtom)
    const setNewsRequestNumberState = useSetRecoilState(type === '0' ? newsRequestNumberState : notaOpRequestNumberState)
    const newsUpdated = () => setNewsRequestNumberState(x => x + 1)
    const fetchNews = useMemo(() => ((id: number) => apiService.getNews(id).then(n => {
        n && setNews(n)
        return n
    })), [setNews])
    return {
        news,
        setNews,
        resetNews,
        newsUpdated,
        fetchNews,
    }
}

export const useResetNews = () => {
    //const setNews = useSetRecoilState(newsAtom)
    //return () => setNews(defaultNewsAtom)
    return useResetRecoilState(newsAtom)

} 

//Used for update
export const updateNewsSelector = selector<News>({
    key: 'newsUpdateCurrent',
    get: ({get}) => {
        //const myList = get(newsListAtom).map(x => x)
        //let rv = myList.find(x => x.id === item.id)
        const rv = get(newsAtom)
        return rv
    },
    set: ({get, set}, newValue) => {
        if (!(newValue instanceof DefaultValue)) {
            if (newValue) {
                const newSd = newValue as News
                const lista = get(newsListAtom)
                const ele = lista.find(x => x.id === newSd.id)
                if (ele) {
                    //Sostituisco il News nell'indice
                    const idx = lista.findIndex(x => x.id === ele.id)
                    if (idx >= 0) {
                        const newLista = [...lista.slice(0, idx), newSd, ...lista.slice(idx + 1)]
                        set(newsListAtom, newLista)
                    }
                }
            }
        }
    }
})

//For Add
export const addNewsSelector = selector<News>({
    key: 'addNews',
    get: ({get}) => {
        //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
        return get(newsAtom)
    },
    set: ({get, set}, itemAdd) => {
        set(newsListAtom, [...get(newsListAtom), itemAdd as News])
    },
})

//For Delete
export const deleteNewsSelector = selector<News>({
    key: 'deleteNewsSelector',
    get: ({get}) => {
        //La get può ritornare qualunque cosa, purchè sia dello stesso tipo del selector
        return get(newsAtom)
    },
    set: ({get, set}, itemToRemove) => {
        // console.log('setting news removed')
        let myNewList = get(newsListAtom).filter(x => x.id !== (itemToRemove as News).id)
        set(newsListAtom, myNewList)
    },
})


// Opzioni per le news
export type NewsOptions = {
    viewAll: boolean,
    limit: number,
}

const initialNewsOptions: NewsOptions = {
    viewAll: false,
    limit: 20,
}

export const newsOptionsState = atom({
    key: 'newsOptionsState',
    default: initialNewsOptions
})

export const useMyNews = () => {
    const [options, setOptions] = useRecoilState(newsOptionsState)
    const newsLoadable = useRecoilValueLoadable(newsState)
    const setRefreshNews = useSetRecoilState(newsRequestNumberState)
    const refresh = (timeout: number = 500) => {
        setTimeout(() => setRefreshNews(p => p + 1), timeout)
    }
    return { newsLoadable, refresh, options, setOptions }
}

